import React from "react"
import { withTheme } from "emotion-theming"

import Circle from "@components/circle"
import Infographic from "@components/infographic"
import { Row, Col } from "@components/grid"

import { People } from "@svgs"

const Main = ({ theme }) => (
  <>
    <h3>Jack Parent Reading Program</h3>
    <Row>
      <Col width={1 / 2}>
        <Infographic
          icon={<People />}
          value="225"
          colour={theme.colours.secondary}
        >
          students reported data for June 2018
        </Infographic>
      </Col>
      <Col width={1 / 2}>
        <Infographic
          icon={<Circle value={83} text="83%" />}
          lg={true}
          colour={theme.colours.primary}
        >
          of the students stated that they liked reading with their tutor
        </Infographic>
      </Col>
    </Row>
    <Row>
      <Col width={1 / 2}>
        <Infographic
          icon={<Circle value={90} text="90%" />}
          lg={true}
          colour={theme.colours.danger}
        >
          of teachers and parents reported an increase in their student's
          self-confidence
        </Infographic>
      </Col>
      <Col width={1 / 2}>
        <Infographic
          icon={<Circle value={94} text="94%" />}
          lg={true}
          colour={theme.colours.success}
        >
          of the students showed improvement in their reading skills
        </Infographic>
      </Col>
    </Row>
  </>
)

export default withTheme(Main)
